import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhatIncludesSection() {
  const includes = ['1 Mentoría privada por Zoom de 90 minutos', 'Diagnóstico estratégico y emocional', 'Plan de acción personalizado', 'Tu primera página web', 'Estructura de tu primer producto digital', 'Acompañamiento vía WhatsApp por 30 días'];
  return <section className="py-24 px-6 max-w-6xl mx-auto" data-id="element-136">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-4 flex items-center gap-3" data-id="element-139">
            <span className="text-brand-gold text-2xl" data-id="element-140">💛</span>
            ¿Qué incluye?
          </h2>
          <h3 className="text-xl font-serif text-brand-gold italic mb-8" data-id="element-141">
            Mentoría intensiva personalizada 1:1
          </h3>

          <div className="space-y-6" data-id="element-142">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-4" data-id="element-143">
                <div className="w-8 h-8 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center shrink-0" data-id="element-144">
                  <Check className="w-4 h-4 text-brand-gold" data-id="element-145" />
                </div>
                <span className="text-brand-cream/90 text-lg font-light" data-id="element-146">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-147">
          <div className="absolute inset-0 bg-brand-gold/15 translate-x-6 translate-y-6 -z-10 rounded-lg" data-id="element-148"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fKV9F7kKn1utxrkeduZLTH/Gemini_Generated_Image_pxf5l1pxf5l1pxf5.png" alt="Materiales de la mentoría" className="w-full h-auto object-cover shadow-2xl rounded-lg" data-id="element-149" />
        </motion.div>
      </div>
    </section>;
}